import type { Configuration } from "@azure/msal-browser";

const clientId = import.meta.env.VITE_MSAL_CLIENT_ID as string;
const tenantId = import.meta.env.VITE_MSAL_TENANT_ID as string;

export const msalConfig: Configuration = {
  auth: {
    clientId: clientId ?? "00000000-0000-0000-0000-000000000000",
    authority: `https://login.microsoftonline.com/${tenantId ?? "common"}`,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
    navigateToLoginRequestUrl: true,
  },
  cache: {
    cacheLocation: "localStorage",
    /**
     * Alleen nodig voor oude browsers waarin localStorage het aanmeldverzoek
     * niet overleeft. Op een gewone site geeft die cookie juist extra storing.
     */
    storeAuthStateInCookie: false,
  },
};

/**
 * Alleen de gegevens die deze app zelf nodig heeft (wie je bent).
 * User.Read (Microsoft Graph) vragen we niet: dat maakte stille vernieuwing
 * vaker onmogelijk, terwijl de server alleen dit id-token controleert.
 */
export const loginRequest = {
  scopes: ["openid", "profile", "email"],
};
